export const fetchDimensionScore = resp => ({
  type: 'FETCH_DIMENSION_SCORE',
  payload: resp,
});
